import moment from 'moment';
import CryptoJS from "crypto-js";

let secretKey = "asfasfdkjashfasjfdlkasjdflkajsfdlajsdflkas"

const encrypt = (string) => {
    if (typeof string !== "string") {
        return "invalid parameter";
    }
    var ciphertext = CryptoJS.AES.encrypt(string, secretKey);
    return ciphertext.toString();

}
const decrypt = (string) => {
    if (typeof string !== "string") {
        return "invalid parameter";
    }
    let bytes = CryptoJS.AES.decrypt(string, secretKey);
    let plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
}

function IsJsonString(str) {
    try {
        var json = JSON.parse(str);
        return json;
    } catch (e) {
        return false;
    }
}

const getYYYYFormat = (date) => {
    let dd = date.getDate();
    if (dd < 10) {
        dd = "0" + dd;
    }
    let mm = date.getMonth();
    mm = mm + 1;
    if (mm < 10) {
        mm = "0" + mm;
    }

    let yyyy = date.getFullYear();
    return `${yyyy}-${mm}-${dd}`;
}

const getLocalItem = key => {
    let value = localStorage.getItem(key);
    value = decrypt(value);
    let json = IsJsonString(value)
    if (json) {
        return json
    }
    return value;
}

const getFilterString = (filters) => {
    let stringToReturn = ""
    for (var key in filters) {
        let value = filters[key];
        if (filters[key]) {
            if (Array.isArray[value]) {
                value = value.join(",");
            }
            if (stringToReturn) {
                stringToReturn += `&${key}=${value}`
            } else {
                stringToReturn += `${key}=${value}`
            }
        }
    }
    return stringToReturn;
}

const setLocalItem = (key, value) => {
    if (typeof value === "object") {
        value = JSON.stringify(value);
    }

    localStorage.setItem(key, encrypt(value));
}

const removeLocalItems = (key) => {
    localStorage.removeItem(key);
}

const weekDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
const isMobile = () => {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

const getValidateData = ({ data, mandatoryFields, validateData }) => {
    let validationData = {}
    for (var key in mandatoryFields) {
        if (validateData[key]) {
            validationData[key] = validateData[key];
        }
        if (mandatoryFields[key] && !data[key]) {
            validationData[key] = `${mandatoryFields[key]} is mandatory.`
        }
    }
    return validationData;
}

const validateField = ({ type, value }) => {
    switch (type) {
        case "email":
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(value).toLowerCase());

        case "mobile":
            let regex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
            return regex.test(value);

    }
}

const getLocation = (getPosition) => {
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(getPosition);
    } else {
        getPosition && getPosition("permission not allowed")
    }
}


const parseDecimal = (value) => {
    return parseFloat(parseFloat(value).toFixed(2));
}

const getUrl = () => {
    let { NODE_ENV } = process.env || {}
    return (NODE_ENV !== "development" ? "https://invoices.fitpass.co.in/v1/l/" : "http://localhost:3000/v1/l/")
}

const getDates = ({ format = "MM DD YYYY" }) => {
    return weekDays.map((value, index) => {
        let today = new Date();
        today.setDate(today.getDate() + index)

        return {
            date: today,
            month: moment(today).format("MMM"),
            day: weekDays[today.getDay()],
            formattedDate: moment(today).format(format)
        }
    })
}

const getQueryParameters = () => {
    return (
        decodeURI(window.location.search)
            .replace('?', '')
            .split('&')
            .map(param => param.split('='))
            .reduce((values, [key, value]) => {
                values[key] = value
                return values
            }, {})
    )
}
// {
//     "@type": "Question",
//      "name": "Best time to eat papaya if wants to lose weight",
//       "acceptedAnswer": {
//                            "@type": "Answer",
//                             "text": "Papaya always help to lose weight have papaya in the morning is good for health and it will as its content 80% of water. &nbsp;"
//                           }
//   }


const getJsonLDFaq = (faqJsonLD) => {
    let mainEntityArray = faqJsonLD.map((item, index) => {
        let { key, value, multipleValue: { type, text } } = item || {}
        return {
            "@type": key,
            "name": value,
            "acceptedAnswer": {
                "@type": type,
                text
            }

        }
    })
    let entityData = { "mainEntity": mainEntityArray }
    return entityData;
}

const getJsonLDBreadcrumb = (breadcrumb) => {
    let breadCrumbListItems = [];
    for (var i = 0; i < breadcrumb.length; i++) {
        var { key, value } = breadcrumb[i];
        breadCrumbListItems.push({
            "@type": "ListItem",
            "position": i + 1,
            "item": {
                "@id": key,
                "name": value
            }

        })
    }
    return breadCrumbListItems;
}

const getJsonLDEvent = (breadcrumb) => {
    let breadCrumbListItems = [];
    for (var i = 0; i < breadcrumb.length; i++) {
        var { key, value } = breadcrumb[i];
        breadCrumbListItems.push({
            "@type": "ListItem",
            "position": i + 1,
            "item": {
                "@id": key,
                "name": value
            }

        })
    }
    return breadCrumbListItems;
}




const getFormattedDate = (date, format = "DD MMM YYYY") => {
    return moment(date).format(format)
}

const getWorkoutListButtonText = (workout_status) => {
    if (workout_status === "1") {
        return "Reserve"
    }
    if (workout_status === "2") {
        return "Reserved"
    }
    if (workout_status === "3") {
        return "Reserve"
    }
}

const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


const checkDecimal = (value) => {
    var decimal = /^[-+]?[0-9]+\.[0-9]+$/;
    return decimal.test(String(value))
}

export {
    isMobile,
    validateField,
    parseDecimal,
    getUrl,
    getValidateData,
    getDates,
    getLocalItem,
    setLocalItem,
    getQueryParameters,
    removeLocalItems,
    getLocation,
    getFilterString,
    getJsonLDFaq,
    getFormattedDate,
    getWorkoutListButtonText,
    getYYYYFormat,
    getJsonLDBreadcrumb,
    getJsonLDEvent,
    capitalizeFirstLetter,
    checkDecimal
}